@if (data().length > 0) {
  <!--#region: drop downs-->
  @if (columnSelectionEnabled()) {
    <div class="control" style="margin-bottom: 10px">
      <div class="field is-grouped">
        <div class="control">
          <label class="label">Add Column</label>
          <select
            (change)="addSelectedColumn($event.target.value)"
            [disabled]="isLoading()"
            class="input"
          >
            <option [value]="null">--</option>
            @for (mapping of columnMappings(); track mapping) {
              @if (!isColumnSelected(mapping)) {
                <option [value]="mapping.property">
                  {{ mapping.heading }}
                </option>
              }
            }
          </select>
        </div>
        <div class="control">
          <label class="label">&nbsp;</label>
          <button class="button" type="button" (click)="clearSelections()">
            Clear
          </button>
        </div>
      </div>
    </div>
  }
  <!--#endregion: drop downs-->
  <!--#region: table-->
  <div class="box" [class.is-loading]="isLoading()">
    <div class="table-wrapper">
      <table
        class="table"
        style="margin-bottom: 10px"
        [class.is-fullwidth]="isFullWidth()"
      >
        <thead>
          <tr class="whitespace-nowrap text-xs [&_th]:align-middle">
            @if (staticColumns()) {
              @for (sc of selectedColumns(); track sc) {
                <th>
                  {{ sc.heading }}
                </th>
              }
            }
            @if (!staticColumns()) {
              @for (sc of selectedColumns(); track sc; let i = $index) {
                <th style="padding-left: 0; padding-right: 0">
                  <div class="field has-addons">
                    @if (i > 0) {
                      <div class="control">
                        <a class="button is-small" (click)="moveColumnLeft(i)">
                          &lt;
                        </a>
                      </div>
                    }
                    <div class="control">
                      @if (!columnSelectionEnabled() || sc.sticky) {
                        <div>
                          <a class="button is-small">{{ sc.heading }}</a>
                        </div>
                      }
                      @if (columnSelectionEnabled() && !sc.sticky) {
                        <div class="select is-small">
                          <select
                            (change)="
                              onSelectedColumnChange(i, $event.target.value)
                            "
                          >
                            <option [value]="sc.property">
                              {{ sc.heading }}
                            </option>
                            @for (mapping of columnMappings(); track mapping) {
                              @if (!isColumnSelected(mapping)) {
                                <option [value]="mapping.property">
                                  {{ mapping.heading }}
                                </option>
                              }
                            }
                          </select>
                        </div>
                      }
                    </div>
                    @if (i < selectedColumns().length - 1) {
                      <div class="control">
                        <a class="button is-small" (click)="moveColumnRight(i)">
                          &gt;
                        </a>
                      </div>
                    }
                    @if (columnSelectionEnabled() && !sc.sticky) {
                      <div class="control">
                        <a
                          class="button is-small"
                          (click)="removeSelectedColumn(sc)"
                        >
                          X
                        </a>
                      </div>
                    }
                  </div>
                </th>
              }
            }
            @for (ac of aggregatedColumns(); track ac) {
              @if (!ac.hidden) {
                <th class="!text-right">
                  {{ ac.heading }}
                </th>
              }
            }
            @if (enableCustomContent()) {
              <th style="width: 10%"></th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of pageRows; track $index) {
            <tr>
              @for (column of row; track column) {
                @if (!column.hidden) {
                  <td
                    [class.!text-right]="isAggregatedColumn(column)"
                    [attr.rowspan]="column.rowspan"
                  >
                    {{ column.value }}
                  </td>
                }
              }
              @if (enableCustomContent()) {
                <td>
                  <ng-container
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: row }"
                  />
                </td>
              }
            </tr>
          }
          @if (selectedColumns().length > 0) {
            @for (stickyRow of stickyRows(); track stickyRow) {
              <tr class="bg-french-blue-50 font-bold">
                <td [attr.colspan]="selectedColumns().length">
                  {{ stickyRow.heading }}
                </td>
                @for (value of stickyRow.values; track value) {
                  <td class="!text-right">
                    {{ value }}
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    <agx-paginator
      [totalItems]="totalItems"
      [itemsPerPage]="itemsPerPage()"
      (pageChange)="onPageChange($event)"
    />
  </div>
  <!--#endregion: table-->
} @else {
  <div
    class="box is-flex"
    style="min-height: 160px; justify-content: center; align-items: center"
    [class.is-loading]="isLoading()"
  >
    <h1 class="has-text-centered is-size-5 is-flex">No data to display</h1>
  </div>
}
